import * as React from "react";
import { SVGProps } from "react";
const SvgOpenInNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#open-in-new_svg__a)">
      <path
        d="m11.95 10-1.794-1.793-2.707 2.707L6.035 9.5l2.707-2.707L6.95 5h5v5Zm-8-7v10h10V3h-10Z"
        fill="#9B9C9E"
      />
    </g>
    <defs>
      <clipPath id="open-in-new_svg__a">
        <path fill="#fff" transform="translate(.95)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOpenInNew;
